module.exports = __webpack_public_path__ + "img/20190615103937272.48f67ad0.png";